// extracted by mini-css-extract-plugin
export default {"header":"social-mentions-pieces-MentionsCardHeader__header--1YbWc"};